import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import conversion from "../../assets/wito.png";
import backImage from "../../assets/fondo.png";
import FieldIcon from "../../utils/Register/field_icon";
import SendBtn from "../../utils/Register/send_btn";
import MenuField from "../../utils/Register/menu_field";
import { jwtDecode } from "jwt-decode";

const PlayerProfile = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [identification, setIdentification] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [birth_date, setDate] = useState("");
  const [review, setReview] = useState("");
  const [error, setError] = useState("");
  const token = useSelector((state) => state.user.token);
  const [userId, setUserId] = useState("");
  const [selectedOption, setSelectedOption] = useState("");

  const options = [
    {
      value: "Ameteur",
      label: "Ameteur",
      tooltip: "This is the first option.",
    },
    {
      value: "Profesional",
      label: "Profesional",
      tooltip: "This is the second option.",
    },
    {
      value: "Profesional retirado",
      label: "Profesional retirado",
      tooltip: "This is the third option.",
    },
    {
      value: "Prefiero no decirlo",
      label: "Prefiero no decirlo",
      tooltip: "This is the third option.",
    },
  ];

  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token);
      setUserId(decodedToken.id);
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !firstName ||
      !lastName ||
      !identification ||
      !phone ||
      !city ||
      !selectedOption ||
      !birth_date
    ) {
      setError(
        "Por favor, complete todos los campos, incluyendo el tipo de jugador."
      );
      return;
    }

    try {
      const response = await fetch(
        "https://server-postgre.vercel.app/api/players",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            first_name: firstName,
            last_name: lastName,
            identification,
            birth_date,
            phone,
            city,
            review,
            user_id: userId,
            player_type: selectedOption,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message);
      }
      window.location.href = "/";
    } catch (error) {
      setError(error.message);
      console.error("Error al crear tu perfil de jugador:", error.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen my-8">
      <div
        className="flex flex-col items-center bg-cover bg-center rounded-xl"
        style={{
          backgroundImage: `url(${backImage})`,
          maxWidth: "420px",
          padding: "0 5%",
          backgroundClip: "padding-box",
        }}
      >
        <div className="text-center text-white mb-8 mt-12">
          <h1 className="text-5xl font-bold">Datos</h1>
          <p className="text-lg mt-2">De jugador</p>
          <div className="flex justify-center mt-2">
            <img src={conversion} alt="Conversión" className="h-8" />
          </div>
        </div>

        <div className="bg-white p-8 rounded-xl shadow-lg w-96">
          <h2 className="text-2xl font-bold text-center mb-6">Jugador</h2>
          <form onSubmit={handleSubmit}>
            <FieldIcon
              id="first_name"
              name="first_name"
              type="text"
              autoComplete="given-name"
              placeholder="Introduce tu nombre"
              value={firstName}
              required
              label="Nombre"
              onChange={(e) => setFirstName(e.target.value)}
            />
            <FieldIcon
              id="last_name"
              name="last_name"
              type="text"
              autoComplete="family-name"
              placeholder="Introduce tu apellido"
              value={lastName}
              required
              label="Apellido"
              onChange={(e) => setLastName(e.target.value)}
            />
            <FieldIcon
              id="identification"
              name="identification"
              type="text"
              autoComplete="identification"
              placeholder="Introduce tu cédula"
              value={identification}
              required
              label="CI"
              onChange={(e) => setIdentification(e.target.value)}
            />
            <FieldIcon
              id="birth_date"
              name="birth_date"
              type="date"
              autoComplete="birth_date"
              placeholder="Introduce tu fecha de nacimiento"
              value={birth_date}
              required
              label="Tu fecha de nacimiento"
              onChange={(e) => setDate(e.target.value)}
            />
            <FieldIcon
              id="phone"
              name="phone"
              type="tel"
              autoComplete="phone"
              placeholder="Introduce tu teléfono"
              value={phone}
              required
              label="Número de teléfono"
              onChange={(e) => setPhone(e.target.value)}
            />
            <FieldIcon
              id="city"
              name="city"
              type="text"
              autoComplete="city"
              placeholder="Introduce tu ciudad"
              value={city}
              required
              label="Introduce tu ciudad"
              onChange={(e) => setCity(e.target.value)}
            />
            <MenuField
              label="Tipo de jugador"
              placeholder="Selecciona una opción"
              options={options}
              selectedOption={selectedOption}
              onOptionSelect={setSelectedOption}
            />
            <FieldIcon
              id="review"
              name="review"
              type="text"
              autoComplete="on"
              placeholder="Sobre ti"
              value={review}
              required
              label="Reseña"
              onChange={(e) => setReview(e.target.value)}
            />
            <SendBtn
              label="Guardar"
              type="submit"
              style={{ backgroundColor: "#E5960E" }}
            />
            {error && <p className="text-red-500">{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default PlayerProfile;
